<template>
  <div class="search">
    <!-- TODO: When the search component is done -->
    <input
      type="text"
      :placeholder="$t('actions.search') + '...'"
      class="search--input"
      :value="dataSource.search"
      @keyup="search($event.target.value)"
    />
    <span class="glicon-fb-search"></span>
  </div>
</template>

<script>
import TableDatasource from './TableDatasource';

export default {
  name: 'TableSearch',
  props: {
    dataSource: {
      type: Object,
      default: () => new TableDatasource()
    }
  },
  data() {
    return {
      timeout: null
    };
  },
  methods: {
    search(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.dataSource.refresh({ search: value, page: 1 });
      }, 500);
    }
  }
};
</script>
